import { App } from 'vue';
import { vFeatureFlag } from '@/composables/featureFlagDirective';

export default {
  install(app: App) {
    // Register the feature flag directive globally
    app.directive('feature-flag', vFeatureFlag);
    
    console.log('Feature flags plugin installed');
  }
};
